export const getTimeAgoFormatted = (createdAt: string | Date): string => {
  const now = new Date()
  const created = new Date(createdAt)
  const diffMs = now.getTime() - created.getTime()

  const totalSeconds = Math.floor(diffMs / 1000)
  const totalMinutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60
  const minutes = totalMinutes % 60
  const hours = Math.floor(totalMinutes / 60) % 24
  const days = Math.floor(totalMinutes / (60 * 24))

  if (totalMinutes < 1) {
    return `${minutes} мин ${seconds} сек`
  }

  if (totalMinutes < 60) {
    return `${minutes} мин ${seconds} сек`
  }

  if (totalMinutes < 1440) {
    return `${Math.floor(totalMinutes / 60)} ч ${minutes} мин`
  }

  return `${days} дн ${hours} ч ${minutes} мин`
}
